module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2BAMAAAB+a3fuAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTCw8UC09UCw8UCo6UCw8UCw8UC07UC47UCo5UC08UHlGv1UAAAAKdFJOUwCfYERghbrmcByTT3O7AAAArklEQVQ4y2NgGAV4gJGSkjImEwxYVwEBlA1iBiDJWRUKCopA2YqCgumLkeS0ElBsYFyCLCcweOSsHIDEtAYgwZEJIhajh00VSMRqGbZg41y1FEhGrcIaphB9y7HKqYFCkbV4SKeZKJDzzZdilVu1qrQjfBX2cIkCpaJV2PUxZwGllhmgC4PjiIFTNU1iAojBhBxHXgKDNp2xoaSzMkReaRQUFF9MZB7DlzdHAToAAAm1NowdZ+4FAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wsii2.png
// module id = eY80
// module chunks = 0